export default {
    waitCount: '/api/web/v2/doctorhomepage/waitcount', // 待办数量
    waitList: '/api/web/v2/doctorhomepage/waitlist', // 待办列表
}